module.exports = __webpack_public_path__ + "media/images/purple-check-deba6f7b.svg";